import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutEditorService {
  private pallette:BehaviorSubject<string> = new BehaviorSubject<string>("default");
  private screenWidth:Subject<number> = new BehaviorSubject<number>(1280);
  
  constructor() { }

  setPallette(name:string):void{
    console.log("setting pallette to: "+name);
    this.pallette.next(name);
  }

  getPallette():Observable<string>{
    return this.pallette.asObservable();
  }

  setScreenWidth(width:number):void{
    this.screenWidth.next(width);
  }

  getScreenWidth():Observable<number>{
    return this.screenWidth.asObservable();
  }
}
